import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
            system: [],
            leads: [],
            sms: [],
            pages: {}
        };
    },

    mutations: {
        setSystemDataFromResponse(state, data) {
            state.system = data || [];
        },
        setLeadsDataFromResponse(state, data) {
            state.leads = data || [];
        },
        setSmsDataFromResponse(state, data) {
            state.sms = data || [];
        },
        setPages(state, data) {
            state.pages = data;
        },
        clearStore(state) {
            state.system = [];
            state.leads = [];
            state.sms = [];
        }
    },
    actions: {
        async getSystem({ state, commit }, params) {
            try {
                const response = await api.get(`/log/system/?${qs.stringify(params)}`);
                commit('setSystemDataFromResponse', response.data.data);
                commit('setPages', response.data.meta);
                return response;
            } catch (e) {
                throw new Error(e);
            }
        },
        async getLeads({ state, commit }, params) {
            try {
                const response = await api.get(`/log/lead/?${qs.stringify(params)}`);
                commit('setLeadsDataFromResponse', response.data.data);
                commit('setPages', response.data.meta);
                return response;
            } catch (e) {
                throw new Error(e);
            }
        },
        async getSms({ state, commit }, params) {
            try {
                const response = await api.get(`/log/sms/?${qs.stringify(params)}`);
                commit('setSmsDataFromResponse', response.data.data);
                commit('setPages', response.data.meta);
                return response;
            } catch (e) {
                throw new Error(e);
            }
        }
    }
};

export default store;
